import { useState } from "react";
import { serializingManga } from "@/mocks/manga";
import MangaCard from "./MangaCard";
import SectionHeader from "./SectionHeader";

const categories = ["全部", "热血冒险", "科幻", "日常美食", "奇幻", "东方玄幻", "青春校园", "都市恋爱", "机甲战斗", "悬疑推理"];

export default function Serializing() {
  const [activeCat, setActiveCat] = useState("全部");
  const [showAll, setShowAll] = useState(false);

  const filtered =
    activeCat === "全部"
      ? serializingManga
      : serializingManga.filter((m) => m.category === activeCat);

  const visible = showAll ? filtered : filtered.slice(0, 6);

  return (
    <section id="serializing" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          tag="追更进行时"
          title="热门连载漫画"
          desc="最新话更新提醒自动同步，进度条直观展示每一部的追更进度，续看永远找得到上次读到的位置。"
        />

        <div className="mb-8 flex flex-wrap gap-2">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => {
                setActiveCat(c);
                setShowAll(false);
              }}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition ${
                activeCat === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {visible.length === 0 ? (
          <p className="py-10 text-center text-sm text-foreground-500">该分类暂无作品，去看看其他分类吧。</p>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6 md:gap-5">
            {visible.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        )}

        {filtered.length > 6 && (
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => setShowAll((v) => !v)}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-100 px-5 py-2.5 text-sm text-foreground-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              {showAll ? "收起" : `展开全部 ${filtered.length} 部`}
              <i className={`text-sm ${showAll ? "ri-arrow-up-line" : "ri-arrow-down-line"}`}></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}